import { useEffect } from 'react'
import { useLayout } from 'hooks'

export function useLayoutHeaderTransparency(isTransparent) {
  const { updatedHeaderTransparency } = useLayout()

  useEffect(() => {
    updatedHeaderTransparency(isTransparent)
  }, [updatedHeaderTransparency, isTransparent])
}

export default useLayoutHeaderTransparency
